"use strict";

var _interopRequireDefault = require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/web.dom.iterable");
var _zhjySerach = _interopRequireDefault(require("@/components/search/zhjySerach.vue"));
var _funBtn = _interopRequireDefault(require("@/components/funBtn/funBtn.vue"));
var _zhjyTable = _interopRequireDefault(require("@/components/table/zhjyTable.vue"));
var _zhjyPagination = _interopRequireDefault(require("@/components/zhjyPagination/zhjyPagination.vue"));
var _competitionColumn = require("@/api/competitionColumn/competitionColumn");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  data: function data() {
    return {
      queryGroup: [{
        label: "作品名称",
        type: "input",
        model: "queryValue",
        placeholder: "作品名称"
      }],
      modelData: {
        queryValue: ""
      },
      defaultColumn: [{
        name: "名称",
        prop: "newsTitle",
        isShow: true,
        width: "100"
      }, {
        name: "封面",
        prop: "imageUrl",
        isShow: true,
        width: "100",
        isImg: true,
        linkColumn: "imageUrl"
        // timeFormat: "dateYMD"
      }, {
        name: "比赛类型",
        prop: "majorCatName",
        isShow: true,
        width: "100"
        // timeFormat: "dateYMD"
      }, {
        name: "层次",
        prop: "courseLevelName",
        isShow: true,
        width: "100"
        // timeFormat: "dateYMD"
      }, {
        name: "年份",
        prop: "yearName",
        isShow: true,
        width: "100",
        timeFormat: "dateYMD"
      },
      // {
      //   name: "创建时间",
      //   prop: "createTime",
      //   isShow: true,
      //   width: "100",
      //   timeFormat: "dateYMD"
      // },
      // {
      //   name: "排序",
      //   prop: "sort",
      //   isShow: true,
      //   width: "100",
      //   // timeFormat: "dateYMD"
      // },
      {
        name: "状态",
        prop: "isPut",
        isShow: true,
        width: "100",
        isFormats: true
        // timeFormat: "dateYMD"
      }],
      minWidth: 200,
      page: {
        pageNumber: 1,
        pageSize: 10
      },
      totalData: 0,
      listData: [],
      formatters: {
        isPut: [{
          name: "已上架",
          value: 1
        }, {
          name: "已下架",
          value: 0
        }]
      },
      sort: {
        prop: "",
        order: ""
      },
      queryValue: "",
      projectLevel: "",
      courseStatus: "",
      repositoryCategory: "",
      checkBoxs: [],
      funBtns: [{
        size: "small",
        click: "morePut",
        name: "批量上架",
        type: "success"
      }, {
        size: "small",
        click: "moreNoPut",
        name: "批量下架",
        type: "warning"
      }, {
        size: "small",
        click: "add",
        name: "新增",
        type: "primary"
      }, {
        size: "small",
        click: "deleteById",
        name: "批量删除",
        type: "danger"
      }],
      options: [{
        name: "上架",
        class: "edit",
        option: "toPut",
        span: 3,
        isFuntion: true,
        optionFun: "putnaniu"
      }, {
        name: "下架",
        class: "edit",
        option: "toPut",
        span: 3,
        isFuntion: true,
        optionFun: "noputnaniu"
      }, {
        name: "编辑",
        class: "edit",
        option: "edit",
        span: 3
      }, {
        name: "删除",
        class: "delet",
        option: "deleteById",
        span: 3
      }],
      isput: {
        idList: [],
        value: 0
      }
    };
  },
  methods: {
    morePut: function morePut() {
      this.isput.idList = this.checkBoxs;
      this.isput.value = 1;
      this.put();
    },
    moreNoPut: function moreNoPut() {
      this.isput.idList = this.checkBoxs;
      this.isput.value = 0;
      this.put();
    },
    toPut: function toPut(e) {
      this.isput.idList.push(e.id);
      e.isPut ? this.isput.value = 0 : this.isput.value = 1;
      this.put();
    },
    put: function put() {
      var _this = this;
      (0, _competitionColumn.workUpdate)(this.isput).then(function (res) {
        if (res.code == 2000) {
          _this.$message.success(res.msg);
          _this.getList();
        }
      });
    },
    //上架按钮显示判断
    putnaniu: function putnaniu(row, callback) {
      if (row.isPut == 0) {
        callback(true);
      } else {
        callback(false);
      }
    },
    noputnaniu: function noputnaniu(row, callback) {
      if (row.isPut == 1) {
        callback(true);
      } else {
        callback(false);
      }
    },
    // 新增
    add: function add() {
      this.$router.push("/competition/indexAdd");
    },
    // 编辑
    edit: function edit(e) {
      this.$router.push({
        path: "/competition/indexEdit",
        query: {
          contestLevelId: e.contestLevelId,
          contestNameId: e.contestNameId,
          contestTypeId: e.contestTypeId,
          createBy: e.createBy,
          // 创建人id
          createTime: e.createTime,
          // 创建时间
          id: e.id,
          isDelete: e.isDelete,
          provinceId: this.$store.getters.provinceId,
          schoolId: e.schoolId,
          status: e.status,
          //发布状态
          updateBy: e.updateBy,
          //修改人
          updateTime: e.updateTime,
          //	更新时间
          workContent: e.workContent,
          workCoverImg: e.workCoverImg,
          workName: e.workName,
          year: e.year
        }
      });
    },
    // 获取作品列表
    getList: function getList() {
      (0, _competitionColumn.workList)({
        contestLevelId: "",
        contestTypeId: "",
        year: ""
      }).then(function (res) {
        var data = res.data;
        console.log("data", data);
        // this.listData = data.list;
        // this.totalData = data.total;
        // console.log('this.listData',this.listData)
      });
    },
    // 模糊搜索新闻分类
    search: function search(val) {
      this.queryValue = val.queryValue;
      this.getList();
    },
    // 删除
    deleteById: function deleteById(row) {
      var _this2 = this;
      console.log('row', row);
      var id = [];
      if (!row && this.checkBoxs.length === 0) {
        return this.$message.error("请先勾选数据");
      } else if (row) {
        id.push(row.id);
      } else if (this.checkBoxs.length > 0) {
        id = this.checkBoxs;
      }
      this.$confirm("确认删除吗", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true
      }).then(function () {
        (0, _competitionColumn.workDelete)({
          idList: id
        }).then(function () {
          _this2.getList();
          _this2.$message.success("操作成功。");
        });
      }).catch(function () {
        _this2.$message.info("取消删除。");
      });
    },
    handleSelectionChange: function handleSelectionChange(e) {
      var _this3 = this;
      this.checkBoxs = [];
      e.forEach(function (item) {
        _this3.checkBoxs.push(item.id);
      });
    },
    distribution: function distribution() {},
    viewAdmin: function viewAdmin() {},
    sortChange: function sortChange() {},
    handleCurrentChange: function handleCurrentChange(e) {
      this.page.pageNumber = e;
      this.getList();
    },
    handleSizeChange: function handleSizeChange(e) {
      this.page.pageSize = e;
      this.page.pageNumber = 1;
      this.getList();
    }
  },
  created: function created() {
    this.getList();
  },
  components: {
    ZhjySerach: _zhjySerach.default,
    ZhjyPagination: _zhjyPagination.default,
    FunBtn: _funBtn.default,
    ZhjyTable: _zhjyTable.default
  }
};